<template>
  <div class="mingxilist">
    <div class="ul_list" v-if="list.length > 0">
      <div class="li_list" v-for="(item, index) in list" :key="index">
        <!-- <div class="liinfo1">{{ JSON.parse(item.content) }}</div> -->
        <div
          class="liinfo1"
          v-for="(item2, index2) in JSON.parse(item.content)"
          :key="index"
        >
          <div>{{ item2.content }}</div>
        </div>

        <div class="liinfo0">
          <span> {{ item.user_name }} {{ item.sex == 1 ? "男" : "女" }}</span
          ><span>{{ item.add_time }}</span>
        </div>
      </div>
    </div>
    <!-- 没有数据 -->
    <div class="nodata" v-if="nodata">
      <div style="height: 2.5rem;"></div>
      <img
        src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_nodata.png"
      />
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getShare, getUserConsultationList } from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "mianzheng_mingxi",
  components: {},
  props: {},
  data: function() {
    return {
      nodata: false,
      page: 1,
      brand_key: "",
      isaddmore: true,
      list: []
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {
    this.getUserConsultationList();
  },
  computed: {},
  methods: {
    getUserConsultationList() {
      if (this.isaddmore) {
        this.isaddmore = false;
        var data = "?limit=20&page=" + this.page + "&brand_key=";
        getUserConsultationList(data)
          .then(res => {
            console.log("成功：", res);
            if (res.data.length <= 0) {
              if (this.page == 1) {
                this.nodata = true;
              }
              this.isaddmore = false;
            } else {
              this.list = this.list.concat(res.data);
              if (res.data.length < 20) {
                this.isaddmore = false;
              } else {
                this.isaddmore = true;
              }
            }
          })
          .catch(err => {
            console.log("err:", err);
          });
      }
    },
    scrollBottom() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      let bottomOfWindow = scrollTop + clientHeight >= scrollHeight - 80;
      console.log(scrollHeight);
      if (scrollTop != 0 && bottomOfWindow && this.isaddmore == true) {
        this.page = this.page + 1;
        this.getUserConsultationList();
      }
    }
  }
};
</script>

<style>
.mingxilist {
  position: relative;
}
.li_list {
  width: 100%;
  /* box-shadow: 0 0.1rem 0.2rem #e2e2e2; */
  /* margin: 0 auto 0.2rem; */
  padding: 0.3rem;
  overflow: hidden;
  /* border-radius: 0.3rem; */
  background-color: #fff;
  border-bottom: 0.02rem solid #f0f0f0;
}
.liinfo0 {
  width: 100%;
  display: flex;
  align-items: baseline;
  font-size: 0.3rem;
  padding: 0.15rem 0;
  justify-content: space-between;
}
.liinfo0 span {
  font-size: 0.3rem;
  display: block;
  color: #333;
}
.liinfo0 span:nth-of-type(2) {
  font-size: 0.26rem;
  display: block;
  color: #666 !important;
}
.liinfo1 {
  width: 100%;
  /* display: flex; */
  align-items: baseline;
  font-size: 0.3rem;
  padding: 0.15rem 0 0;
  color: #ff410a;
}
/* .liinfo1 span {
  font-size: 0.26rem;
  display: block;
  width: 1.2rem;
  margin-right: 0.02rem;
  color: #666;
} */
.nodata {
  width: 100%;
  text-align: center;
}

.nodata img {
  display: block;
  width: 4rem;
  margin: 0 auto;
}

.nodata p {
  font-size: 0.3rem;
  margin-top: 0.02rem auto 0;
  color: #999;
  text-align: center;
}
</style>
